/**
 * 認証ガードコンポーネント
 * 認証が必要なページへのアクセス制御
 */

import { Navigate } from 'react-router-dom'
import { useSupabaseAuth } from '@/shared/hooks/useSupabaseAuth'

/**
 * 認証ガードのプロパティ
 */
interface AuthGuardProps {
  children: React.ReactNode
}

/**
 * 認証ガードコンポーネント
 * 未認証ユーザーをログインページにリダイレクト
 */
export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { user, isLoading } = useSupabaseAuth()

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}